import { AxiosResponse } from 'axios';
import { API } from 'core';
import { ServerRoute } from 'core/api';
import { ProviderFilesApiService } from 'core/providerFilesApiService';
import { IFileDownload, ManualDownloadLink } from 'core/models';

export class FileService {
  public static async download(controller: string, id: string): Promise<IFileDownload> {
    if (controller.startsWith('/')) {
      controller = controller.substring(1);
    }
    const route: ServerRoute = ServerRoute.forAction(controller, id);
    const result: AxiosResponse = await API.getFullResponse(route, undefined, { responseType: 'blob' });
    const disposition = result.headers['content-disposition'];
    const filename = disposition && /filename=(.*);/.exec(disposition)[1];

    return {
      disposition,
      file: result.data,
      filename,
      type: result.headers['content-type'],
    };
  }

  public static async downloadProviderFiles({ fileName, id }: ManualDownloadLink): Promise<IFileDownload> {
    const route: ProviderFilesApiService = new ProviderFilesApiService();
    const data = await route.getActivityContentsAsync(id);

    return {
      disposition: fileName,
      file: data,
      type: data.type,
    };
  }

  public static async downloadLearnerValidationProviderFiles({
    fileName,
    id,
  }: ManualDownloadLink): Promise<IFileDownload> {
    const route: ProviderFilesApiService = new ProviderFilesApiService();
    const data = await route.getLearnerValidationContentsAsync(id);

    return {
      disposition: fileName,
      file: data,
      type: data.type,
    };
  }
}
